import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(true);
  const [validToken, setValidToken] = useState(false);

  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        toast.error("Invalid reset link.");
        return navigate("/login");
      }

      try {
        const res = await axios.get(
          `https://api.bbsfacultyprofile.com/api/reset-password/validate/${token}`
        );
        if (res.data.valid) {
          setValidToken(true);
        } else {
          toast.error("Invalid or expired reset link.");
          navigate("/login");
        }
      } catch (err) {
        toast.error("Unable to validate reset link.");
        navigate("/login");
      } finally {
        setValidating(false);
      }
    };

    checkToken();
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validToken) return;

    if (newPassword !== confirmPassword) {
      toast.warning("Passwords do not match!");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `https://api.bbsfacultyprofile.com/api/reset-password/${token}`,
        { newPassword }
      );
      toast.success(res.data.message || "Password reset successfully!");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  if (validating) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#f0f4f8",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        Validating link...
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f4f8",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
      />
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "12px",
          width: "350px",
          boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Reset Password
        </h2>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <label>New Password:</label>
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            style={{
              padding: "10px",
              margin: "10px 0",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
          <label>Confirm Password:</label>
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={{
              padding: "10px",
              margin: "10px 0",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: "#2196F3",
              color: "white",
              padding: "10px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              marginTop: "10px",
              fontWeight: "bold",
            }}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
        <p style={{ marginTop: "15px", textAlign: "center" }}>
          Remembered your password?{" "}
          <button
            onClick={() => navigate("/login")}
            style={{
              background: "none",
              border: "none",
              color: "#2196F3",
              cursor: "pointer",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            Login
          </button>
        </p>
      </div>
    </div>
  );
}
